import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ApiErrorDialogComponent } from '../../Dialog/api-error-dialog/api-error-dialog.component';
import { parseApiError } from './api-error-message.util';
import { WhatsappThemeService } from './whatsapp-theme.service';

@Injectable({
  providedIn: 'root'
})
export class ApiErrorDialogService {
  constructor(
    private dialog: MatDialog,
    private whatsappThemeService: WhatsappThemeService
  ) {}

  private get dialogConfig() {
    return {
      width: '520px',
      maxWidth: '96vw',
      autoFocus: false,
      panelClass: this.whatsappThemeService.isDarkMode() ? ['api-error-dialog-panel', 'ticket-dialog-dark'] : ['api-error-dialog-panel']
    };
  }

  openFromError(err: any, fallback: string, title = 'No se pudo completar la acción'): void {
    const data = parseApiError(err, fallback, title);
    this.dialog.open(ApiErrorDialogComponent, {
      ...this.dialogConfig,
      data
    });
  }

  openInfo(title: string, message: string, closeText = 'Entendido'): void {
    this.dialog.open(ApiErrorDialogComponent, {
      ...this.dialogConfig,
      data: { title, message, source: 'INFO', closeText }
    });
  }

  openErrorMessage(message: string, title = 'No se pudo completar la acción'): void {
    this.dialog.open(ApiErrorDialogComponent, {
      ...this.dialogConfig,
      data: { title, message, source: 'BACKEND', severity: 'error' }
    });
  }

  openWarningMessage(message: string, title = 'Revisá la información'): void {
    this.dialog.open(ApiErrorDialogComponent, {
      ...this.dialogConfig,
      data: { title, message, source: 'BACKEND', severity: 'warning' }
    });
  }
}
